<template>
  <div class="range-picker-wrapper">
    <div class="d-flex range-picker" :class="bordered">
      <TextTimePicker
        :input-value="fromHour"
        :time="fromHour"
        :externalValidation="externalValidation"
        class="time-picker-from"
        @select="updateFromTime"
        :required="required"
        :disableValidation="disableValidation"
      />
      <div class="to-divider">to</div>
      <TextTimePicker
        :input-value="toHour"
        :time="toHour"
        :externalValidation="externalValidation"
        class="time-picker-to"
        @select="updateToTime"
        :disableValidation="disableValidation"
      />
    </div>
    <ValidationProvider
      v-slot="{ errors }"
      name="validateHours"
      rules="required|validTimeRange"
      v-if="required"
    >
      <v-text-field
        :error-messages="showValidationErrors ? errors : ''"
        readonly
        class="input-hidden"
        :value="timeRange"
      />
    </ValidationProvider>
  </div>
</template>

<script>
import TextTimePicker from "@/components/common/TimePicker/TextTimePicker";
import { ValidationProvider } from "vee-validate";

export default {
  name: "TimeRangePicker",
  components: { TextTimePicker, ValidationProvider },
  props: {
    fromHour: String,
    toHour: String,
    required: Boolean,
    showValidationErrors: Boolean,
    bordered: Boolean,
    disableValidation: Boolean
  },
  methods: {
    updateFromTime(fromHour) {
      this.$emit("updateRange", { fromHour, toHour: this.toHour });
    },
    updateToTime(toHour) {
      this.$emit("updateRange", { toHour, fromHour: this.fromHour });
    }
  },
  computed: {
    timeRange() {
      return this.fromHour && this.toHour
        ? `${this.fromHour}-${this.toHour}`
        : null;
    },
    externalValidation() {
      return Boolean(this.timeRange) || this.disableValidation;
    }
  }
};
</script>

<style lang="scss"></style>
